//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SalesCard from "@/components/SalesCard";
import DiamondsPopover from "@/components/DiamondsPopover";
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  components: { SalesCard, DiamondsPopover },
  methods: {
    toShopPage() {
      this.$emit("shop");
    },
    onDetailClick() {
      this.$emit("change");
    },
  },
};
